import { useState, useEffect } from "react";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useGetProfileByIdQuery } from "../../redux/profileApiV3";
import useUserId from "./useUserId";
import { getJourneyAndProgrammeIds } from "../../utils/JourneyUtils";
/**
 * Custom React hook for using user's current journey and programme Ids.
 * @returns {Array} [currentJourneyAndProgrammeIds, isReady]
 */
export function useCurrentJourneyAndProgrammeIds() {
  const [currentJourneyAndProgrammeIds, setCurrentJourneyAndProgrammeIds] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const [userId] = useUserId();
  const { data: profile, isSuccess, isUninitialized } = useGetProfileByIdQuery(userId ?? skipToken);

  useEffect(() => {
    if (isSuccess && !isUninitialized) {
      const journeyAndProgrammeIds = getJourneyAndProgrammeIds(profile);
      setCurrentJourneyAndProgrammeIds(journeyAndProgrammeIds);
      setIsReady(true);
    }
  }, [profile, isSuccess, isUninitialized]);

  return [currentJourneyAndProgrammeIds, isReady];
}
